module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.7012/img/blobsRight.png"